import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { isString } from '@sa/utils';

import { store } from '@/store';

import { getCacheUserInfo, getToken } from './shared';

const initialState = {
  permissions: {} as Record<string, boolean>,
  token: getToken(),
  userInfo: getCacheUserInfo()
};

export const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    resetAuth: () => initialState,
    setPermissions(state, { payload }: PayloadAction<string[]>) {
      const perMap: Record<string, boolean> = {};
      payload.forEach(key => {
        perMap[key] = true;
      });
      state.permissions = perMap;
    },
    setToken: (state, { payload }: PayloadAction<string>) => {
      state.token = payload;
    },
    setUserInfo: (state, { payload }: PayloadAction<Api.Auth.UserInfo>) => {
      state.userInfo = payload;
    }
  },
  selectors: {
    selectPermissions: auth => auth.permissions,
    selectToken: auth => auth.token,
    selectUserInfo: auth => auth.userInfo
  }
});

export const { resetAuth, setPermissions, setToken, setUserInfo } = authSlice.actions;

export const { selectPermissions, selectToken, selectUserInfo } = authSlice.selectors;

/** Is login */
// export const getIsLogin = createSelector([selectToken], token => Boolean(token));
export const getIsLogin = createSelector([selectToken], () => true);

/** Is static super role */
export const isStaticSuper = createSelector([selectUserInfo], userInfo => {
  const { VITE_AUTH_ROUTE_MODE, VITE_STATIC_SUPER_ROLE } = import.meta.env;

  return VITE_AUTH_ROUTE_MODE === 'static' && userInfo.roles.includes(VITE_STATIC_SUPER_ROLE);
});

export const hasPermission = (per: string | string[], strict: boolean = false) => {
  const permission = selectPermissions(store.getState());
  if (isString(per)) {
    // eslint-disable-next-line no-param-reassign
    per = [per];
  }
  return strict ? per.every(key => permission[key]) : per.some(key => permission[key]);
};
